module.exports = __webpack_public_path__ + "img/a4c19017c6c94106b34b5b2e45042d50-1440.785a84d1.jpg";